<template>
  <v-list v-if="selectedService">
    <v-subheader class="mb-n4">{{ $t("bookingForm.BookingSelectedService.selectedServiceHeader") }}</v-subheader>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-subtitle>
          <div class="text-caption">
            {{ partner.companyName }} -

            <span v-if="partner.address" class="ml-1">
              {{ partner.address.street }},
              {{ partner.address.zip }}
              {{ partner.address.city }}
            </span>
          </div>
        </v-list-item-subtitle>
        <v-list-item-title>
          {{ selectedService.name }}
          <booking-back-button v-if="showBackButton" @click="goToServiceOverview" />
        </v-list-item-title>
        <v-list-item-subtitle v-if="selectedService.isDisplayDuration">
          {{ $t("bookingForm.common.minutes", { value: selectedService.duration / 60 / 1000 }) }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script lang="ts">
import { BookingSlotViewModelGen } from "@/services/booking/v1/data-contracts";
import { AvailabilityModule } from "@/store/modules/availability.store";
import { Component, Vue, Prop } from "vue-property-decorator";
import BookingBackButton from "./BookingBackButton.vue";
import { PartnerModule } from "@/store/modules/partner";
@Component({
  components: {
    BookingBackButton
  }
})
export default class BookingSelectedService extends Vue {
  @Prop({ default: true })
  showBackButton!: boolean;

  get selectedService() {
    return AvailabilityModule.selectedService;
  }

  goToServiceOverview() {
    AvailabilityModule.setServices();
  }

  get selectedSlot() {
    return AvailabilityModule.selectedSlot;
  }

  set selectedSlot(slot: BookingSlotViewModelGen | undefined) {
    AvailabilityModule.setSelectedSlot(slot);
  }

  get partner() {
    return PartnerModule.partner;
  }
}
</script>
